import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Card, Form, Icon, ButtonGroup, Button } from '@shopify/polaris';
import AppLinkItem from './AppLinkItem';

const propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
  })),
  parentName: PropTypes.string, // display purposes
  parentListAccessor: PropTypes.string, // accessor i.e. "app_links" || "app_links[0].sublinks" || "app_links[etc].sublinks[etc].sublinks"
  deepLevel: PropTypes.number,

  handleLinkAction: PropTypes.func.isRequired,
  handleLinkRemove: PropTypes.func.isRequired,
  handleLinkPositionChange: PropTypes.func.isRequired,
}

const defaultProps = {
  deepLevel: 0,
}

const AppLinksForm = (props) => {

  const addNewSublink = () => {
    props.handleLinkAction("CREATE", props.parentListAccessor, null, props.deepLevel + 1 )
  }

  const paddingLeft = props.deepLevel * 20;
  const numberOfLinksOnParent = (!!props.links && props.links.length || 0);

  return (
    <div style={{ backgroundColor: "#DEE1E8", border: "1px solid #DEE1E8", borderRight: "none" }}>
      <div style={{ paddingLeft: paddingLeft }}>
        { props.links.map( (link, index) => 
          <AppLinkItem 
            key={index} itemIndex={ index } 
            parentAccessor={ props.parentListAccessor } deepLevel={props.deepLevel + 1}
            link={ link } 
            numberOfLinksOnParent={ numberOfLinksOnParent }
            handleLinkAction={ props.handleLinkAction } 
            handleLinkRemove={ props.handleLinkRemove }
            handleLinkPositionChange={ props.handleLinkPositionChange }
          />
        )}
        {/*TODO Deeplevel max (SHOULD BE A PROP) , deepLevel starts at 0*/}
        { props.deepLevel <= 2 &&
          <div className="pv10 pl10 bg-white" style={{ border: "1px solid #DEE1E8", borderRight: "none", borderBottom: "none", borderLeft: "none" }}>
            <Button onClick={ addNewSublink } plain>
              Agregar link <strong>{ !!props.parentName ? `a ${props.parentName}` : '' }</strong>
            </Button>
          </div>
        }
      </div>
    </div>
  )
};

AppLinksForm.propTypes = propTypes;
AppLinksForm.defaultProps = defaultProps;

export default AppLinksForm;